function Email({ value, handleValue }) {
   return (
      <div className="group">
         <label htmlFor="email">Email</label>
         <input
            type="email"
            id="email"
            required
            autoComplete="off"
            placeholder="you@example.com"
            value={value}
            onChange={e => handleValue(e.target.value, 'email')}
         />
      </div>
   )
}

export default Email
